window.openSellingModalSuccess = function openSellingModalSuccess() {
    if (document.getElementById('selling-estate-modal-form-success')) {
        document.getElementById('selling-estate-modal-form-success').classList.add('open');
    }
};

window.closeSellingModalSuccess = function closeSellingModalSuccess() {
    if (document.getElementById('selling-estate-modal-form-success')) {
        document.getElementById('selling-estate-modal-form-success').classList.remove('open');
    }
};

window.openSellingModal = function openSellingModal() {
    closeSellingModalSuccess();
    if (document.getElementById('selling-estate-modal')) {
        document.getElementById('selling-estate-modal').classList.add('open');
    }
};

window.closeSellingModal = function closeSellingModal() {
    if (document.getElementById('selling-estate-modal')) {
        document.getElementById('selling-estate-modal').classList.remove('open');
    }
};
